<script>
export default {

    name: 'create-quiz-results',

}
</script>

<template lang="html">
    <div class="">

    </div>
</template>



// WEBPACK FOOTER //
// src/pages/tools/quizzes/edit/Results.vue